import { AbstractControl, ValidationErrors } from '@angular/forms';

export const noWhitespaceValidator = (control: AbstractControl): ValidationErrors | null => {
    const value = control.value || '';

    return value.trim().length > 0 ? null : { whitespace: true };
};
